
import { SecurityZonesModel } from '../models/security-zones-model';
import { ZoneFeature } from '../models/zones-base-interfaces';
import { ZoneLayerBase } from './zone-layer-base';

export class SecurityZonesLayer extends ZoneLayerBase {
    async getZones(): Promise<ZoneFeature[]> {
        const zones = await SecurityZonesModel!.getSecurityZones();
        return zones || [];
    }
    zoneId: string = "SecurityZonesLayer";
}
